import React from 'react';
import { StorageService } from '../services/storageService';
import { 
  DocumentTextIcon, 
  MusicalNoteIcon
} from '@heroicons/react/24/outline';

type ArticleImageVariant = 'articleList' | 'allArticles' | 'dashboard';

interface ArticleImageProps {
  imageUrl?: string;
  alt: string;
  variant: ArticleImageVariant;
  isAudio: boolean;
}

const ArticleImage: React.FC<ArticleImageProps> = ({
  imageUrl,
  alt,
  variant,
  isAudio
}) => {
  const getPreviewUrl = (width: number, height: number): string => {
    if (!imageUrl) return '';
    return StorageService.getImagePreviewUrlFromStorageUrl(imageUrl, width, height);
  };

  if (variant === 'articleList') {
    const previewUrl = getPreviewUrl(352, 224);

    return (
      <div className="flex-shrink-0 flex items-stretch">
        {imageUrl ? (
          <img
            src={previewUrl}
            loading="lazy"
            alt={alt}
            className="w-44 object-cover rounded-md bg-gray-100"
            onError={(e) => {
              const img = e.currentTarget;
              if (img.dataset.fallback !== 'true') {
                img.dataset.fallback = 'true';
                img.src = imageUrl;
              } else {
                img.style.display = 'none';
              }
            }}
          />
        ) : (
          <div className="w-44"></div>
        )}
      </div>
    );
  }

  if (variant === 'allArticles') {
    const previewUrl = getPreviewUrl(352, 224);

    return (
      <div className="flex-shrink-0 flex items-stretch mb-4 md:mb-0">
        {imageUrl ? (
          <img
            src={previewUrl}
            loading="lazy"
            alt={alt}
            className="w-full md:w-44 h-48 md:h-28 object-cover rounded-md bg-gray-100"
            onError={(e) => {
              const img = e.currentTarget;
              if (img.dataset.fallback !== 'true' && imageUrl) {
                img.dataset.fallback = 'true';
                img.src = imageUrl;
              } else {
                img.style.display = 'none';
              }
            }}
          />
        ) : (
          <div className="w-full md:w-44 h-48 md:h-28 bg-gray-100 rounded-md flex items-center justify-center">
            {isAudio ? (
              <MusicalNoteIcon className="w-12 h-12 text-gray-400" />
            ) : (
              <DocumentTextIcon className="w-12 h-12 text-gray-400" />
            )}
          </div>
        )}
      </div>
    );
  }

  const previewUrl = getPreviewUrl(352, 224);

  return (
    <div className="flex-shrink-0 flex items-stretch mb-4 md:mb-0">
      {imageUrl ? (
        <img
          src={previewUrl}
          loading="lazy"
          alt={alt}
          className="w-full md:w-44 h-48 md:h-28 object-cover rounded-md bg-gray-100"
          onError={(e) => {
            const img = e.currentTarget;
            if (img.dataset.fallback !== 'true' && imageUrl) {
              img.dataset.fallback = 'true';
              img.src = imageUrl;
            } else {
              img.style.display = 'none';
            }
          }}
        />
      ) : (
        <div className="w-full md:w-44 h-48 md:h-28 bg-gray-100 rounded-md flex items-center justify-center">
          {isAudio ? (
            <MusicalNoteIcon className="w-12 h-12 text-gray-400" />
          ) : (
            <DocumentTextIcon className="w-12 h-12 text-gray-400" />
          )}
        </div>
      )}
    </div>
  );
};

export default ArticleImage;
